import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
export const store = new Vuex.Store({
    state: {
        jwt: localStorage.getItem('jwt')
    },
    mutations: {
        setJwt(state, jwt) {
            state.jwt = jwt;
        }
    },
    getters: {
        jwt: state => {
            return state.jwt
        }
    },
    actions: {
        setJwt(context, jwt) {
            context.commit('setJwt', jwt);
        }
    },
});
